module.exports = __webpack_public_path__ + "static/media/not.bb2b323b.svg";